import { FC } from 'react'

import { GridPairs } from '@builddocs/mui'
import { useDisclosure } from '@builddocs/system'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Paper,
  Stack,
  Box,
} from '@mui/material'
import Draggable from 'react-draggable'

function PaperComponent(props) {
  return (
    <Draggable
      cancel={'[class*="MuiDialogContent-root"]'}
      handle="#draggable-feedback-dialog-title"
    >
      <Paper {...props} />
    </Draggable>
  )
}

type OwnProps = {
  mode?: 'icon' | undefined
}

const Feedback: FC<OwnProps> = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box>
      <Link
        color="text.primary"
        sx={{ cursor: 'pointer' }}
        underline="hover"
        onClick={onOpen}
      >
        Техническая поддержка
      </Link>
      <Dialog
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-feedback-dialog-title"
        id="feedback-dialog"
        maxWidth="sm"
        open={isOpen}
        onClose={onClose}
      >
        <DialogTitle
          id="draggable-feedback-dialog-title"
          style={{ cursor: 'move' }}
        >
          Техническая поддержка
        </DialogTitle>
        <DialogContent>
          <DialogContentText mb={2}>
            По вопросам связанным с использованием сервиса можно обращаться по
            нашим каналам связи
          </DialogContentText>
          <Stack spacing={1}>
            <GridPairs
              isBlack
              content={[
                [
                  'Позвонить',
                  <Link
                    key="Позвонить"
                    href="tel:+79313376642"
                    target="_blank"
                    underline="none"
                  >
                    +79313376642
                  </Link>,
                ],
                [
                  'Написать',
                  <Link
                    key="Написать"
                    href="mailto:help@builddocs.ru"
                    target="_blank"
                    underline="none"
                  >
                    help@builddocs.ru
                  </Link>,
                ],
                [
                  'Написать в Telegram',
                  <Link
                    key="Написать"
                    href="https://t.me/BuildDocs_support"
                    target="_blank"
                    underline="none"
                  >
                    @BuildDocs_support
                  </Link>,
                ],
              ]}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={onClose}>
            Закрыть
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default Feedback
